import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useParamsFormat from "../../../common/Params Values format/ParamsFormat";
import { ListquizManagementSlice } from "../../../redux/features/Quiz Management/QuizManagementByManual";
import CustomPagination from "../../../common/Pagination/Pagination";
import TableSkeleton from "../../../common/Skeleton";
import { MdCancelPresentation } from "react-icons/md";
import { ListingQuizFromApiSlice } from "../../../redux/features/Quiz Management/QuizManagementByAPI";

const DeletedQuizByApi = () => {
  const dispatch = useDispatch();
  const [pagination, setPagination] = useState({});
  const [iState, setUpdate] = useState([]);
  const { createDataSetParams } = useParamsFormat();
  const [dataForHold, setDataForHold] = useState({
    filterTheData: true,
  });

  const [getSearch, setGetSearch] = useState({
    search: "",
    fromDate: "",
    toDate: "",
    timeframe: "",
    page: 1,
  });
  const [timeFrame, setTimeFrame] = useState("");

  const { loading } = useSelector((state) => state?.QuizManagement);

  useEffect(() => {
    const status = "deleted";
    const params = createDataSetParams({ ...getSearch });
    dispatch(ListingQuizFromApiSlice({ status, params }))?.then((res) => {
      if (res?.payload?.customStatus === 200) {
        setUpdate(res.payload?.data?.quiz);
        setPagination(res?.payload?.data?.pagination);
      }
    });
  }, [dataForHold?.filterTheData]);

  const hanldeFetchData = (PageNumber) => {
    setGetSearch((prev) => ({ ...prev, page: PageNumber }));
    const status = "deleted";
    const params = createDataSetParams({ ...getSearch, page: PageNumber });
    dispatch(
      ListingQuizFromApiSlice({ status, params })
    ).then((res) => {
      if (res?.payload?.customStatus === 200) {
        setUpdate(res.payload?.data?.quiz);
        setPagination(res?.payload?.data?.pagination);  
      }
    });
  };

  const handleReset = () => {
    if (
      getSearch?.search?.length === 0 &&
      getSearch?.toDate?.length === 0 &&
      getSearch?.fromDate?.length === 0
    )
      return;
    setGetSearch((prev) => ({ ...prev, search: "", fromDate: "", toDate: "" }));

    setDataForHold((prev) => ({
      ...prev,
      filterTheData: !prev["filterTheData"],
    }));
  };

  const handleTimeFrame = (e) => {
    const selectedValue = e?.target?.value?.trim();

    if (!selectedValue) return;

    setGetSearch((prev) => ({ ...prev, search: "", fromDate: "", toDate: "" }));

    setTimeFrame(selectedValue);

    setDataForHold((prev) => ({ ...prev, timeframe: selectedValue }));

    const status = "deleted";
    const params = createDataSetParams({
      ...getSearch,
      timeframe: selectedValue,
    });

    dispatch(ListingQuizFromApiSlice({ status, params })).then((res) => {
      if (res?.payload?.customStatus === 200) {
        setUpdate(res.payload?.data?.quiz);
        setPagination(res?.payload?.data?.pagination);
      }
    });
  };

    useEffect(()=>{
     const storeTimer = setTimeout(() => {
       dispatch(ListingQuizFromApiSlice({status: "deleted", params: createDataSetParams(getSearch)})).then(
        (res) => {
          setUpdate(res.payload?.data?.quiz);
          setPagination(res?.payload?.data?.pagination);
        }
      );
     },500)
  
      return ()=> clearTimeout(storeTimer)
    },[getSearch.search])

  return (
    <>
      <div className="Small-Wrapper">
        <div className="FilterArea">
          <div className="FilterLeft">
            <div className="form-group">
              <label>Search</label>
              <input
                type="text"
                name="search"
                value={getSearch?.search}
                onChange={(e) => {
                  setGetSearch((prev) => ({
                    ...prev,
                    fromDate: "",
                    toDate: "",
                  }));
                  setTimeFrame(""); //resetTime Frame

                  setGetSearch((prev) => ({
                    ...prev,
                    [e.target.name]: e.target.value,
                  }));
                }}
                className="form-control"
                placeholder="Search here"
              />
            </div>
            <div className="form-group">
              <label>From Date</label>
              <input
                type="date"
                name="fromDate"
                value={getSearch?.fromDate}
                max={getSearch?.toDate || undefined}
                onChange={(e) => {
                  setGetSearch((prev) => ({ ...prev, search: "" }));
                  setTimeFrame(""); //resetTime Frame
                  setGetSearch((prev) => ({
                    ...prev,
                    [e.target.name]: e.target.value,
                  }));
                }}
                className="form-control"
              />
            </div>
            <div className="form-group">
              <label>To Date</label>
              <input
                type="date"
                name="toDate"
                value={getSearch?.toDate}
                min={getSearch?.fromDate || undefined}
                onChange={(e) => {
                  setGetSearch((prev) => ({ ...prev, search: "" }));
                  setTimeFrame(""); //resetTime Frame
                  setGetSearch((prev) => ({
                    ...prev,
                    [e.target.name]: e.target.value,
                  }));
                }}
                className="form-control"
              />
            </div>
            <div className="form-group">
              <label>&nbsp;</label>
              <button
                className="Button"
                onClick={() =>
                  setDataForHold((prev) => ({
                    ...prev,
                    filterTheData: !prev["filterTheData"],
                  }))
                }
              >
                Apply
              </button>

              <button className="Button Cancel" onClick={handleReset}>
                <i className="fa fa-refresh" />
              </button>
            </div>
          </div>
          <div className="FilterRight">
            <div className="form-group">
              <label>Timeframe</label>
              <select
                className="form-control"
                name="timeframe"
                value={timeFrame}
                onChange={handleTimeFrame}
              >
                <option value="">Select Timeframe</option>{" "}
                {/* Add an empty value for default */}
                <option value="today">Today</option>
                <option value="this_week">This Week</option>
                <option value="this_month">This Month</option>
                <option value="this_year">This Year</option>
              </select>
            </div>
          </div>
        </div>
        <div className="TableList">
          <table>
            <thead>
              <tr>
                <th>S.No.</th>
                <th>Quiz ID</th>
                <th>Quiz Category</th>
                <th>Posted On</th>
                <th>Paper Name</th>
                <th>Duration</th>
                <th>Article Status</th>
                {/* <th>Action</th> */}
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <TableSkeleton />
              ) : Array.isArray(iState) && iState?.length === 0 ? (
                <tr>
                  <td colSpan={10}>There is no data found</td>
                </tr>
              ):( 
                iState?.map((item, index) => {
                  return (
                    <tr>
                      <td>{(pagination?.currentPage - 1) * 10 + index + 1}</td>{" "}
                      <td>{item?.quizId}</td>
                      <td>{item?.quizDetail?.quizcategory}</td>
                      <td>{item?.createdAt?.slice(0, 10)}</td>
                      <td>{item?.quizDetail?.papername}</td>
                      <td>{item?.quizDetail?.duration}</td>
                      <td>
                        <span className="Green">{item?.status}</span>
                      </td>
                      {/* <td>
                        <div className="Actions">
                          <a
                            onClick={() => setDataForHold(item?._id)}
                            className="Red"
                            data-toggle="modal"
                            data-target="#RejectModal"
                            title="Reject"
                          >
                            <MdCancelPresentation
                              style={{ color: "red", fontSize: "17px" }}
                            />
                          </a>
                          <a className="Green" href="">
                            <i className="fa fa-eye" aria-hidden="true" />
                          </a>
                          <a
                            className="Red"
                            data-toggle="modal"
                            data-target="#DeleteModal"
                          >
                            <i className="fa fa-trash" aria-hidden="true" />
                          </a>
                        </div>
                      </td> */}
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
        {pagination?.totalPages > 1 && (
          <CustomPagination
            activePage={pagination?.currentPage}
            itemsCountPerPage={pagination?.perPage}
            totalItemsCount={pagination?.totalPages}
            pageRangeDisplayed={5}
            hanldeFetchData={hanldeFetchData}
            itemClass={"page-item"}
            linkClass={"page-link"}
          />
        )}
      </div>

      <div className="ModalBox">
        <div id="LogoutModal" className="modal fade" role="dialog">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-body">
                <div className="Decline">
                  <a
                    href="javascript:void(0);"
                    className="CloseModal"
                    data-dismiss="modal"
                  >
                    ×
                  </a>
                  <h3>Logout</h3>
                  <p>Are you sure you want to log out? </p>
                  <h4>
                    <a href="javascript:void(0);" data-dismiss="modal">
                      no
                    </a>
                    <a href="login.html">Yes</a>
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="DeleteModal" className="modal fade" role="dialog">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-body">
                <div className="Decline">
                  <a
                    href="javascript:void(0);"
                    className="CloseModal"
                    data-dismiss="modal"
                  >
                    ×
                  </a>
                  <h3>Delete</h3>
                  <p>Are you sure you want to Delete? </p>
                  <h4>
                    <a href="javascript:void(0);" data-dismiss="modal">
                      no
                    </a>
                    <a href="javascript:void(0);" data-dismiss="modal">
                      Yes
                    </a>
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          id="ActiveModal"
          className="modal fade ExtraSmallModal"
          role="dialog"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-body">
                <div className="Decline">
                  <a
                    href="javascript:void(0);"
                    className="CloseModal"
                    data-dismiss="modal"
                  >
                    ×
                  </a>
                  <h3>Active</h3>
                  <p>Are you sure you want to active?</p>
                  <h4>
                    <a href="javascript:void(0);" data-dismiss="modal">
                      no
                    </a>
                    <a href="javascript:void(0);" data-dismiss="modal">
                      Yes
                    </a>
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          id="InactiveModal"
          className="modal fade ExtraSmallModal"
          role="dialog"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-body">
                <div className="Decline">
                  <a
                    href="javascript:void(0);"
                    className="CloseModal"
                    data-dismiss="modal"
                  >
                    ×
                  </a>
                  <h3>Inactive</h3>
                  <p>Are you sure you want to inactive ?</p>
                  <h4>
                    <a href="javascript:void(0);" data-dismiss="modal">
                      no
                    </a>
                    <a href="javascript:void(0);" data-dismiss="modal">
                      Yes
                    </a>
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          id="AddQuizCategoryModal"
          className="modal fade"
          style={{ display: "none" }}
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-body">
                <div className="Category">
                  <a
                    href="javascript:void(0);"
                    className="CloseModal"
                    data-dismiss="modal"
                  >
                    ×
                  </a>
                  <h3>Add QUIZ Category</h3>
                  <div className="form-group">
                    <label>Category Title</label>
                    <input
                      type="password"
                      className="form-control"
                      placeholder="Auto fill "
                    />
                  </div>
                  <div className="form-group">
                    <label>Upload Image </label>
                    <div className="UploadBox">
                      <div className="Upload">
                        <i className="fa fa-upload" /> <span>Upload </span>
                        <input type="file" />
                      </div>
                    </div>
                  </div>
                  <button className="Button">Add Quiz Category</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DeletedQuizByApi;
